<ion-row
  data-cy="promotion-title-row"
  class="promotion-title-row ion-align-items-center"
  (click)="handleUpdateExpansionEvent()"
  [class.touch]="platformService?.isTouchExperience$ | async"
  [class.expanded]="divisionalPromotion?.isExpanded"
>
  <ion-col
    class="promotion-title-description-column"
    data-cy="promotion-title-description-column"
    size="7"
  >
    <ion-label data-cy="sortable-section-title-text">
      {{ divisionalPromotion?.promotionDescription | titlecase }}
    </ion-label>
    <ion-icon
      [name]="
        divisionalPromotion?.isExpanded
          ? 'chevron-up-outline'
          : 'chevron-down-outline'
      "
    ></ion-icon>
  </ion-col>

  <ion-col
    data-cy="promotion-title-actions-column"
    class="promotion-end-date-column ion-text-right ion-justify-content-end"
    size="5"
  >
    <ion-label data-cy="sortable-section-title-text">
      {{ 'i18n.sellerShowcasePage.promotionEndDate' | translate }}:
      {{ divisionalPromotion?.endEffDate | date: 'MM/dd/yyyy' }}
    </ion-label>
  </ion-col>
</ion-row>

<ng-container *ngIf="divisionalPromotion?.isExpanded">
  <ng-container
    *ngIf="
      platformService?.platformType === platformService?.platformEnum?.desktop
    "
  >
    <ng-container *ngTemplateOutlet="desktopPromotionalProducts"></ng-container>
  </ng-container>
  <ng-container
    *ngIf="
      platformService?.platformType !== platformService?.platformEnum?.desktop
    "
  >
    <ng-container *ngTemplateOutlet="devicesPromotionalProducts"></ng-container>
  </ng-container>
</ng-container>

<ng-template #desktopPromotionalProducts>
  <app-sortable-section-desktop-tablet
    [showTitle]="false"
    [sectionHeaders]="
      divisionalPromotion?.productsAreAvailable ? sectionHeaders : []
    "
    [selectedHeader]="selectedHeaderName"
    [disabledHeaders]="disabledHeaders"
    [hasSectionData]="
      divisionalPromotion?.promotionalProducts?.length > 0 ||
      !divisionalPromotion?.productsAreAvailable
    "
    [noDataText]="'i18n.sellerShowcasePage.noProductsToShow' | translate"
    (updateSortEventEmitter)="handleUpdateSortEvent($event)"
  >
    <cdk-virtual-scroll-viewport
      *ngIf="divisionalPromotion?.promotionalProducts?.length > 0"
      appCustomVs
      [itemHeights]="divisionalPromotion?.itemHeights"
      [items]="divisionalPromotion?.products"
      [measureViewportSize]="false"
    >
      <ion-card
        [attr.data-cy]="
          'seller-showcase-divisional-promotion-product-card-' + i
        "
        class="product-card-desktop"
        [class.has-warning-drawer]="
          promotionalProduct?.product?.drawerMsg?.isWarning ||
          promotionalProduct?.product?.productCardWarningMsg?.display
        "
        *cdkVirtualFor="
          let promotionalProduct of divisionalPromotion?.promotionalProducts;
          let i = index;
          trackBy: trackByProductNumber
        "
      >
        <app-product-card-drawer
          [drawerMessage]="promotionalProduct?.product?.drawerMsg"
          [warningMessage]="promotionalProduct?.product?.productCardWarningMsg"
        >
        </app-product-card-drawer>
        <ion-row class="promotional-product-section-data-row">
          <ion-col
            [size]="sectionHeaders[0]?.size"
            [attr.data-cy]="'thumbnail-container-col-' + i"
            (click)="handleProductClick(promotionalProduct, i + 1, true)"
          >
            <div class="thumbnail-container">
              <img
                *ngIf="
                  isOnline && !!promotionalProduct?.product?.imageThumbnail
                "
                [attr.data-cy]="'thumbnail-image-' + i"
                src="{{ promotionalProduct?.product?.imageThumbnail }}"
                class="thumbnail {{ platformService?.platformType }}"
              />
              <ion-icon
                *ngIf="
                  isOnline === false ||
                  !promotionalProduct?.product?.imageThumbnail
                "
                [attr.data-cy]="'thumbnail-no-image-' + i"
                name="restaurant"
                class="thumbnail no-image {{ platformService?.platformType }}"
              ></ion-icon>
            </div>
          </ion-col>

          <ion-col
            [size]="sectionHeaders[1]?.size"
            [attr.data-cy]="'product-number-text-col-' + i"
          >
            <p>{{ promotionalProduct?.productNumber }}</p>
          </ion-col>

          <ion-col
            [size]="sectionHeaders[2].size"
            [attr.data-cy]="'description-text-col-' + i"
            (click)="handleProductClick(promotionalProduct, i + 1, false)"
          >
            <p class="link-text">
              {{
                promotionalProduct?.product?.summary?.productDescTxtl || ' '
                  | acronymTitleCase
              }}
            </p>
          </ion-col>

          <ion-col
            [size]="sectionHeaders[3]?.size"
            [offset]="sectionHeaders[3]?.offset"
            [attr.data-cy]="'brand-name-text-col' + i"
          >
            <p>
              {{
                promotionalProduct?.product?.summary?.brand || ' '
                  | acronymTitleCase
              }}
            </p>
          </ion-col>

          <ion-col
            [size]="sectionHeaders[4]?.size"
            [attr.data-cy]="'quantity-col' + i"
          >
            <div class="pricing-row">
              <app-product-card-ordering
                [productSummary]="promotionalProduct?.product?.summary"
                [pricing]="promotionalProduct?.product?.pricing"
                [casesOrdered]="promotionalProduct?.product?.casesOrdered"
                [eachesOrdered]="promotionalProduct?.product?.eachesOrdered"
                [isOrderable]="promotionalProduct?.product?.orderable"
                [isOnline]="isOnline"
                [platformType]="platformService?.platformType"
                [index]="i"
                [hotkeyIds]="promotionalProduct?.product?.hotkeyIds"
                [pricingDisabled]="pricingDisabled"
                [mode]="usfProductCardModeEnum.defaultSearch"
                [notFound]="promotionalProduct?.product?.notFound"
                [isShippingPriceSingleLineDisplay]="true"
                (quantityUpdateEmitter)="
                  handleQuantityChange($event, promotionalProduct)
                "
              >
              </app-product-card-ordering>
            </div>
          </ion-col>

          <ion-col
            [size]="sectionHeaders[5]?.size"
            [attr.data-cy]="'ellipsis-col' + i"
          >
            <app-product-card-ellipsis
              (ellipsisClickEmitter)="
                handleEllipsisClick($event, promotionalProduct)
              "
            ></app-product-card-ellipsis>
          </ion-col>
        </ion-row>
      </ion-card>
    </cdk-virtual-scroll-viewport>
    <div
      *ngIf="!divisionalPromotion?.productsAreAvailable"
      class="spinner-container"
    >
      <ion-spinner name="circles" data-cy="loading-spinner-icon"></ion-spinner>
    </div>
  </app-sortable-section-desktop-tablet>
</ng-template>

<ng-template #devicesPromotionalProducts>
  <cdk-virtual-scroll-viewport
    appCustomVs
    [itemHeights]="divisionalPromotion?.itemHeights"
    [items]="divisionalPromotion?.products"
    [measureViewportSize]="false"
  >
    <ion-card
      *cdkVirtualFor="
        let promotionalProduct of divisionalPromotion?.promotionalProducts;
        let i = index;
        trackBy: trackByProductNumber
      "
      class="product-card-devices"
      [class.has-warning-drawer]="
        promotionalProduct?.product?.drawerMsg?.isWarning ||
        promotionalProduct?.product?.productCardWarningMsg?.display
      "
      [attr.data-cy]="'seller-showcase-divisional-promotion-product-card-' + i"
    >
      <app-product-card-drawer
        [drawerMessage]="promotionalProduct?.product?.drawerMsg"
        [warningMessage]="promotionalProduct?.product?.productCardWarningMsg"
        (infoIconClickEmitter)="
          handleProductClick(promotionalProduct, i + 1, false)
        "
      >
      </app-product-card-drawer>
      <div class="product-card-details-container">
        <div
          class="thumbnail-col"
          (click)="handleProductClick(promotionalProduct, i + 1, true)"
          [attr.data-cy]="'thumbnail-container-col-' + i"
        >
          <div class="thumbnail-container">
            <img
              *ngIf="isOnline && promotionalProduct?.product?.imageThumbnail"
              [attr.data-cy]="'thumbnail-image-' + i"
              src="{{ promotionalProduct?.product?.imageThumbnail }}"
              class="thumbnail"
            />
            <ion-icon
              *ngIf="
                isOnline === false ||
                !promotionalProduct?.product?.imageThumbnail
              "
              [attr.data-cy]="'thumbnail-no-image-' + i"
              name="restaurant"
              class="thumbnail no-image"
            ></ion-icon>
          </div>
        </div>
        <div class="details-col" [attr.data-cy]="'product-details-col-' + i">
          <div class="product-details">
            <p class="brand-text">
              {{
                promotionalProduct?.product?.summary?.brand || ' '
                  | acronymTitleCase
              }}
            </p>
            <p
              class="link-text"
              [ngClass]="platformService?.platformType"
              (click)="handleProductClick(promotionalProduct, i + 1, false)"
            >
              {{
                promotionalProduct?.product?.summary?.productDescTxtl || ' '
                  | acronymTitleCase
              }}
            </p>
            <p class="product-number">
              #{{ promotionalProduct?.productNumber }}
            </p>
          </div>
        </div>
        <div class="ellipsis-col" [attr.data-cy]="'ellipsis-col' + i">
          <app-product-card-ellipsis
            class="ellipsis-btn"
            [class.has-drawer]="
              !!promotionalProduct?.product?.drawerMsg?.message ||
              promotionalProduct?.product?.productCardWarningMsg?.display
            "
            (ellipsisClickEmitter)="
              handleEllipsisClick($event, promotionalProduct)
            "
          ></app-product-card-ellipsis>
        </div>
      </div>
      <div class="product-card-pricing-container">
        <app-product-card-ordering
          [productSummary]="promotionalProduct?.product?.summary"
          [pricing]="promotionalProduct?.product?.pricing"
          [casesOrdered]="promotionalProduct?.product?.casesOrdered"
          [eachesOrdered]="promotionalProduct?.product?.eachesOrdered"
          [isOrderable]="promotionalProduct?.product?.orderable"
          [isOnline]="isOnline"
          [platformType]="platformService?.platformType"
          [index]="i"
          [hotkeyIds]="promotionalProduct?.product?.hotkeyIds"
          [pricingDisabled]="pricingDisabled"
          [mode]="usfProductCardModeEnum.defaultSearch"
          [notFound]="promotionalProduct?.product?.notFound"
          [isShippingPriceSingleLineDisplay]="true"
          (quantityUpdateEmitter)="
            handleQuantityChange($event, promotionalProduct)
          "
        >
        </app-product-card-ordering>
      </div>
    </ion-card>
  </cdk-virtual-scroll-viewport>
  <div
    *ngIf="!divisionalPromotion?.productsAreAvailable"
    class="spinner-container"
  >
    <ion-spinner name="circles" data-cy="loading-spinner-icon"></ion-spinner>
  </div>
  <ion-card
    *ngIf="
      !divisionalPromotion?.promotionalProducts?.length &&
      divisionalPromotion?.productsAreAvailable
    "
    class="product-card-devices"
    [attr.data-cy]="
      'seller-showcase-divisional-promotion-product-card-empty-results'
    "
  >
    <div class="product-card-details-container">
      <div class="empty-results-col">
        <p>{{ 'i18n.sellerShowcasePage.noProductsToShow' | translate }}</p>
      </div>
    </div>
  </ion-card>
</ng-template>
